import { CommonApi } from '@/api/common';
import CommonStore from '@/store/common';
import { StoreService } from '@/services/store-service';

export class CommonService {

    constructor(client, store, router) {                
        this.api = new CommonApi(client);
        this.store = StoreService.new(store, CommonStore);        
        this.router = router;
    }
    
    async listRoles(){
        const cachedItems = this.store.get('roles');
        if(cachedItems) return cachedItems;

        const response = await this.api.listRoles();
        await this.store.dispatch('setRoles', response.roles);

        return response.roles;
    }

    async sendFeedback(data){
        const response = await this.api.sendFeedback(data);
        return response;
    }
}